@if (!reorder() && bucket().isSetup) {
  <div class="relative flex min-h-[64px] flex-1" [class.income]="bucket().type === 'INCOME'">
    <button
      appUiButton
      appearance="ghost"
      tone="neutral"
      type="button"
      class="category-bucket-summary-button !min-h-16 min-w-0 flex-1 items-center justify-start gap-6 !rounded-none !border-0 bg-transparent px-category-bucket-x py-category-bucket-y"
      (click)="openDrawer(bucket())"
    >
      <ng-container *ngTemplateOutlet="bucketSummary" />
    </button>
    <button
      appUiButton
      appearance="ghost"
      tone="neutral"
      type="button"
      class="category-bucket-summary-balance-button !min-h-16 !min-w-category-bucket-balance flex-col items-end justify-center gap-0 !rounded-none !border-0 bg-transparent px-category-bucket-balance-right py-category-bucket-y md:!min-w-category-bucket-balance-desktop"
      (click)="openTransferDrawer(bucket())"
    >
      <ng-container *ngTemplateOutlet="balance" />
    </button>
  </div>
} @else {
  <div
    class="relative flex min-h-[64px] flex-1 items-center px-category-bucket-x py-category-bucket-y"
    [class.income]="bucket().type === 'INCOME'"
    [class.pl-category-bucket-left]="!bucket().isSetup"
    [class.pr-0]="reorder() || !bucket().isSetup"
  >
    <ng-container *ngTemplateOutlet="bucketSummary" />
    <ng-container *ngTemplateOutlet="balance" />
  </div>
}

<ng-template #bucketSummary>
  @if (bucket().isSetup) {
    <div class="flex w-full items-center gap-4">
      @if (!bucket()._pendingCreate) {
        <div class="relative shrink-0">
          <app-bucket-progress
            class="block h-category-bucket-progress w-category-bucket-progress"
            [bucket]="bucket()"
          />
        </div>
      } @else {
        <div
          class="flex h-category-bucket-progress w-category-bucket-progress shrink-0 items-center justify-center rounded-full border border-dashed border-border-default bg-surface-subtle text-text-muted"
          aria-hidden="true"
        >
          <app-ui-icon name="add" class="size-6" />
        </div>
      }
      <div
        class="flex min-w-0 flex-1 flex-col items-start justify-center"
        [class.overflow-hidden]="!reorder()"
        [class.opacity-75]="bulkEdit.isPendingArchive(bucket().id)"
        [class.opacity-100]="bulkEdit.isPendingUnarchive(bucket().id)"
      >
        @if (!reorder()) {
          <div class="w-full truncate text-left text-[14px] font-bold leading-tight text-text-title">
            {{ bucket().name }}
          </div>
          <app-category-bucket-summary-info [bucket]="bucket()" class="w-full">
            @if (bucket().archivedMonth) {
              <span>&nbsp;- ARCHIVED</span>
            }
            <!-- Transfers are excluded by policy, not by choice — marking every one of
                 them would be noise, matching the group header's excluded count. -->
            @if (bucket().excludedFromSpendingReports && bucket().type !== 'TRANSFERS') {
              <span>&nbsp;- EXCLUDED</span>
            }
          </app-category-bucket-summary-info>
        }
        @if (reorder()) {
          @if (bucket()._pendingCreate) {
            <span class="mb-1 text-xs font-semibold uppercase tracking-wide text-brand-primary">New budget</span>
          }
          @if (!bulkEdit.isPendingArchive(bucket().id)) {
            <input
              appUiInput
              type="text"
              name="bucketName"
              maxlength="32"
              class="!m-0 !h-auto !min-h-0 w-full !rounded-none !border-0 !border-b !border-border-default !bg-transparent !px-0 !py-1 !text-base !font-bold !leading-tight !text-text-title !shadow-none focus:!outline-none focus-visible:!outline-none focus-visible:!ring-0 focus-visible:!border-brand-primary"
              [ngModel]="bulkEdit.draftBucketName(bucket())"
              (ngModelChange)="updateReorderName($event)"
              aria-label="Budget name"
            />
          }
          @if (bulkEdit.isPendingArchive(bucket().id)) {
            <div class="w-full truncate text-left text-base font-bold leading-tight text-text-title">
              {{ bulkEdit.draftBucketName(bucket()) || bucket().name }}
            </div>
          }
          @if (bulkEdit.isPendingArchive(bucket().id)) {
            <div class="mt-0.5 font-mono text-base leading-tight tabular-nums text-text-subtle">
              {{ unsignedSpent | currency: 'USD' : 'symbol' : '1.0-2' }} /
              {{ bulkEdit.draftBucketAmount(bucket()) | currency: 'USD' : 'symbol' : '1.0-2' }}
            </div>
          } @else {
            <div
              class="mt-1.5 flex w-full flex-wrap items-center gap-x-4 gap-y-2 font-mono text-base leading-tight tabular-nums text-text-subtle"
            >
              @if (bucket()._pendingCreate) {
                <app-bucket-type-selector
                  class="shrink-0"
                  [compact]="true"
                  [type]="bucketTypeValue()"
                  (typeChange)="updatePendingType($event)"
                />
              }
              <div class="flex min-w-0 items-center gap-1">
                <span class="shrink-0">{{ unsignedSpent | currency: 'USD' : 'symbol' : '1.0-2' }} /</span>
                <div class="relative">
                  <span
                    class="pointer-events-none absolute left-0 top-1/2 -translate-y-1/2 text-base text-text-subtle"
                    aria-hidden="true"
                    >$</span
                  >
                  <input
                    appUiInput
                    type="number"
                    name="bucketAmount"
                    min="0"
                    step="0.01"
                    class="!m-0 !h-auto !min-h-0 w-28 !rounded-none !border-0 !border-b !border-border-default !bg-transparent !px-0 !pl-6 !py-1 !text-base !font-mono !leading-tight !tabular-nums !shadow-none focus:!outline-none focus-visible:!outline-none focus-visible:!ring-0 focus-visible:!border-brand-primary [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                    [ngModel]="bulkEdit.draftBucketAmount(bucket())"
                    (ngModelChange)="updateReorderAmount($event)"
                    (wheel)="$any($event.target).blur()"
                    aria-label="Monthly amount"
                  />
                </div>
              </div>
            </div>
          }
        }
      </div>
      @if (reorder()) {
        <div class="ml-auto grid w-10 shrink-0 items-center justify-items-center">
          @if (bucket()._pendingCreate) {
            <app-ui-icon-button
              icon="close"
              tone="danger"
              size="sm"
              ariaLabel="Remove pending budget"
              (click)="removePendingBucket(bucket())"
            />
          } @else {
            <app-ui-icon-button
              [tone]="bulkEdit.isPendingArchive(bucket().id) ? 'neutral' : 'danger'"
              [icon]="
                bucket().archivedMonth || bulkEdit.isPendingArchive(bucket().id) || bulkEdit.isPendingUnarchive(bucket().id)
                  ? 'undo'
                  : 'trash'
              "
              [ariaLabel]="
                bucket().archivedMonth && !bulkEdit.isPendingUnarchive(bucket().id)
                  ? 'Unarchive budget'
                  : bulkEdit.isPendingArchive(bucket().id) || bulkEdit.isPendingUnarchive(bucket().id)
                    ? 'Undo budget archive change'
                    : 'Archive budget'
              "
              (click)="openArchiveDialog(bucket())"
            />
          }
        </div>
      }
    </div>
  } @else {
    <form
      class="flex-1 sm:flex sm:items-center"
      #bucketSetupForm="ngForm"
      [formGroup]="formGroup"
      (ngSubmit)="submitSetupBucket()"
    >
      <div
        class="mb-category-bucket-setup-title w-full truncate text-left text-[16px] font-bold leading-tight sm:hidden"
      >
        {{ bucket().name }}
      </div>
      <app-ui-field
        class="hidden sm:mr-category-bucket-balance sm:block"
        label="Budget Name"
        [inputId]="'category-bucket-summary-name-' + bucket().id"
      >
        <input
          [id]="'category-bucket-summary-name-' + bucket().id"
          appUiInput
          type="text"
          formControlName="name"
          name="name"
          autocomplete="off"
        />
      </app-ui-field>
      <div class="flex items-center gap-2">
        <app-ui-field label="Monthly Amount" [inputId]="'category-bucket-summary-amount-' + bucket().id">
          <div class="relative">
            <span
              class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-text-muted"
              aria-hidden="true"
              >$</span
            >
            <input
              [id]="'category-bucket-summary-amount-' + bucket().id"
              appUiInput
              formControlName="amount"
              class="pl-[2.25rem]"
              type="number"
              min="0.00"
              step="0.01"
              placeholder="0.00"
              autocomplete="off"
              name="amount"
            />
          </div>
        </app-ui-field>
        <button
          appUiButton
          class="!min-h-compact min-w-[3rem] self-end px-2"
          type="submit"
          tone="accent"
          [disabled]="updateBucketMutation.isPending()"
          aria-label="save budget"
        >
          @if (updateBucketMutation.isPending()) {
            <span aria-hidden="true">…</span>
          } @else {
            <app-ui-icon name="check" class="size-[18px]" />
          }
          <span class="sr-only">{{ updateBucketMutation.isPending() ? 'Saving budget' : 'Save budget' }}</span>
        </button>
        <button
          appUiButton
          appearance="outline"
          class="!min-h-compact min-w-[3rem] self-end px-2"
          type="button"
          tone="danger"
          [disabled]="deleteBucketMutation.isPending()"
          aria-label="delete budget"
          (click)="deleteBucket(bucket())"
        >
          <span aria-hidden="true">{{ deleteBucketMutation.isPending() ? '…' : 'Delete' }}</span>
          <span class="sr-only">{{ deleteBucketMutation.isPending() ? 'Deleting budget' : 'Delete budget' }}</span>
        </button>
      </div>
    </form>
    <div class="flex-1"></div>
    <button
      appUiButton
      appearance="ghost"
      class="!min-h-compact self-center px-2"
      type="button"
      tone="accent"
      (click)="openDrawer(bucket())"
      aria-label="open budget in drawer"
    >
      <span aria-hidden="true">Open</span>
    </button>
  }
</ng-template>

<ng-template #balance>
  @if (bucket().isSetup && !reorder()) {
    <div class="flex flex-col items-end text-right text-[16px] font-extrabold tabular-nums leading-tight">
      <app-balance-amount [bucket]="bucket()" />
      @if (bucket().fund?.goal; as fundGoal) {
        <span class="mt-category-bucket-goal block text-[12px] font-normal text-text-muted">
          of {{ fundGoal | currency: 'USD' : 'symbol' : '1.0-2' }}
        </span>
      }
      @if (bucketService.isIncomeAndBehind(bucket())) {
        <span class="mt-category-bucket-goal block text-[12px] font-normal text-text-muted">expected</span>
      }
    </div>
  }
</ng-template>
